import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TourService } from '../../services/tour.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {

  breadcrumbs: Array<{ label: string, url: string, description?:string }> = [];
  constructor(private router: Router, private cookieService: CookieService, private translate: TranslateService, private tourService: TourService) {
    const savedLang = this.cookieService.get('language') || 'en';
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
  }

  ngOnInit(): void {
    this.getBreadcrumbs().subscribe(breadcrumbs => {
      this.breadcrumbs = breadcrumbs;
    });
  }

  // Optional: Hides certain breadcrumbs on smaller screens
  isHidden(breadcrumb: { label: string, url: string }, last: boolean): boolean {
    // Add logic here for determining which breadcrumbs to hide, e.g., based on index or screen size
    return false;
  }

  getBreadcrumbs(): Observable<Array<{ label: string, url: string }>> {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.createBreadcrumbs(this.router.routerState.snapshot.root))
    );
  }

  private createBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url: string = '',
    breadcrumbs: Array<{ label: string; url: string; description?: string }> = []
  ): Array<{ label: string; url: string; description?: string }> {
    const label = route.data['breadcrumb'];
    const description = route.data['description'];
    const path = route.url.map(segment => segment.path).join('/');
    const nextUrl = path ? `${url}/${path}` : url;

    const breadcrumb: { label: string; url: string; description?: string } = {
      label,
      url: nextUrl,
      ...(description ? { description } : {})
    };

    const newBreadcrumbs = label ? [...breadcrumbs, breadcrumb] : breadcrumbs;

    return route.firstChild
      ? this.createBreadcrumbs(route.firstChild, nextUrl, newBreadcrumbs)
      : newBreadcrumbs;
  }


  startServiceTour() {
    this.tourService.startServiceTour.next();
  }
}
